import { FC } from "react";
import { css } from "@emotion/css";
import { Box } from "@analyticsMD/quil";
import PatientInsightsNote from "../../types/PatientInsightsNote";
import InsightItemQuote from "./insight-item-quote";
import InsightItemNoteHeader from "./insight-item-note-header";

const styles = {
  noteList: css`
    margin: 0.25rem 0 0;
    padding-left: 0;
    font-size: 0.85rem;
  `,
};

interface InsightItemNoteProps {
  note: PatientInsightsNote;
  setShowToast: (showToast: boolean) => void;
  setShowErrorToast: (showToast: boolean) => void;
  insightTypeFilter: string[];
}

const InsightItemNote: FC<InsightItemNoteProps> = ({
  note,
  setShowToast,
  setShowErrorToast,
  insightTypeFilter,
}) => {
  const filteredQuotes =
    insightTypeFilter.length > 0
      ? note.quotes.filter((q) => insightTypeFilter.includes(q.insight_type))
      : note.quotes;
  return (
    <>
      <Box sx={{ flex: 1 }}>
        {filteredQuotes.length > 0 && (
          <InsightItemNoteHeader noteHeader={note.header} />
        )}
        <ul className={styles.noteList}>
          {filteredQuotes.map((q, index) => (
            <InsightItemQuote
              insightNoteID={note.id}
              score={q.score}
              quote={q}
              key={index}
              setShowToast={setShowToast}
              setShowErrorToast={setShowErrorToast}
            />
          ))}
        </ul>
      </Box>
    </>
  );
};

export default InsightItemNote;
